import themedefault from './themedefault';
import themecustom from './themecustom';

const themes = {
  themedefault,
  themecustom,
};
export default themes;
